import { axios } from '@Root/API'

export const get = (studyProgrammeId, venueActivityId) => {
	return axios.get(`course-session/${studyProgrammeId}/off-venue-activity/${venueActivityId}`)
}
